// ⓘ tájékoztató buborék — közös vezérlés.
//
// 2026-09-20: eddig a kezdőlapi vélemény-szekció {% javascript %} blokkjában
// élt. A terméklap is ugyanezt a mintát kapta (a megbízó kérése), ezért közös
// fájlba került — így nem tud kettéválni a két viselkedés.
//
// Elvárt jelölés:
//   <button class="pm-testi__info-btn" aria-expanded="false" aria-controls="AZONOSÍTÓ">…</button>
//   <div class="pm-testi__info-pop" id="AZONOSÍTÓ" role="note" hidden>…</div>
//
// Kattintásra nyílik, nem rámutatásra: érintőképernyőn a hover nem elérhető.
(function () {
  if (window.__pmInfoPop) return;
  window.__pmInfoPop = true;

  function zarMindet(kiveve) {
    document.querySelectorAll('.pm-testi__info-btn[aria-expanded="true"]').forEach(function (btn) {
      if (btn === kiveve) return;
      btn.setAttribute('aria-expanded', 'false');
      var pop = document.getElementById(btn.getAttribute('aria-controls'));
      if (pop) pop.hidden = true;
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.pm-testi__info-btn') : null;
    if (btn) {
      var pop = document.getElementById(btn.getAttribute('aria-controls'));
      var nyit = btn.getAttribute('aria-expanded') !== 'true';
      zarMindet(btn);
      btn.setAttribute('aria-expanded', nyit ? 'true' : 'false');
      if (pop) pop.hidden = !nyit;
      return;
    }
    if (!(e.target.closest && e.target.closest('.pm-testi__info-pop'))) zarMindet(null);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') zarMindet(null);
  });
})();
